export enum InvoicePaymentStatus {
    Open = 'Open',
    PartiallyPaid = 'PartiallyPaid',
    Paid = 'Paid',
}